module.exports = __webpack_public_path__ + "static/ipv-cfcd14077efeea6d3c01b0db0e61950e.jpg";